<template>
  <h6>Einzelcoaching-Maßnahmenn</h6>
  <div class="table-responsive overflow-auto">
    <table class="table table-striped">
      <thead>
      <tr>
        <th>Status</th>
        <th>Maßnahmenart</th>
        <th>Office</th>
        <th>Start</th>
        <th>Ende</th>
        <th>Stand</th>
        <th>Stand %</th>
        <th>UN fehlt</th>
        <th>Coach 1</th>
        <th>UE Coach 1</th>
        <th>Coach 2</th>
        <th>UE Coach 2</th>
        <th>Coach 3</th>
        <th>UE Coach 3</th>
        <th>Coach 4</th>
        <th>UE Coach 4</th>
        <th>Geva Testung</th>
        <th>Noch abzurechnende Stunden</th>
        <th>Letzter Termin</th>
        <th></th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="(coaching, index) in privateCoachingList" :key="index">
        <td style="min-width: 100px;"> {{ coaching.statusTranslated }}</td>
        <td> {{ coaching.nameOfCoaching.operationTypeTranslated }}
        </td>
        <td>
          <strong class="js-lists-values-employee-name">
            <span v-if="
              coaching.type === 'regular' ||
              coaching.type === '' ||
              coaching.type === null ||
              coaching.type === undefined">
              {{ coaching.unemployed?.location?.name }}
            </span>
            <span v-else>
              <span v-for="(office, i) in coaching.offices" :key="i">
                {{ office.office.name }}
                <template v-if="i < coaching.offices.length - 1">, &nbsp;</template>
              </span>
            </span>
          </strong>
        </td>
        <td>{{ coaching.startDate }}</td>
        <td>{{ coaching.endDate }}</td>
        <td>{{ coaching.unitsHeld }}</td>
        <td>{{ coaching.unitsHeldPercent }}%</td>
        <td style="text-align: center"> {{ coaching.notSignedUnits }}</td>
        <td>{{ coaching.coach1?.firstName }} {{ coaching.coach1?.lastName }}</td>
        <td>{{ coaching.unitsHeldCoach1 }}</td>
        <td>{{ coaching.coach2?.firstName }} {{ coaching.coach2?.lastName }}</td>
        <td>{{ coaching.unitsHeldCoach2 }}</td>
        <td>{{ coaching.coach3?.firstName }} {{ coaching.coach3?.lastName }}</td>
        <td>{{ coaching.unitsHeldCoach3 }}</td>
        <td>{{ coaching.coach4?.firstName }} {{ coaching.coach4?.lastName }}</td>
        <td>{{ coaching.unitsHeldCoach4 }}</td>
        <td style="text-align: center"> {{ coaching.gevaStatusTranslated }}</td>
        <td style="text-align: center"> {{ coaching.countNotBilledMeetings }}</td>
        <td>{{ coaching.lastUnit }}</td>
        <td>
          <router-link
              :to="{
                  name: 'analyticsUnemployedDetailsOverviewCoachingDetails',
                  params: {
                    coachingType: 'private-coaching',
                    id: coaching.id
                  }
                }"
              class="btn btn-primary">
            Analytik
          </router-link>
        </td>
      </tr>
      </tbody>
    </table>
  </div>
</template>

<script setup>
import { defineProps } from 'vue';

const props = defineProps({
  privateCoachingList: {
    require: true,
  },
});
</script>

<style scoped>

</style>